import CharField from '@/views/CustomForms/fields/CharField'
import ChoiceField from '@/views/CustomForms/fields/ChoiceField'
import TextField from '@/views/CustomForms/fields/TextField'
import FileField from '@/views/CustomForms/fields/FileField'
import CheckboxField from '@/views/CustomForms/fields/CheckboxField'

export default {
  CharField,
  ChoiceField,
  TextField,
  FileField,
  CheckboxField
}
